<template>
  <div :class="b()">
    <e-button
      v-for="brand in brands"
      :key="brand.id"
      :class="b('brand-button')"
      :negative="!(activeValue === brand.label)"
      size="large"
      icon="i-chevron-1--right"
      icon-position="right"
      @click="onSelected(brand)"
    >
      {{ brand.label }}
    </e-button>
  </div>
</template>

<script>
  import { URL_PARAM_MAP } from '@/setup/globals';
  import eButton from '@/elements/e-button.vue';

  /**
   * Renders a component to display all brands with a list of buttons.
   */
  export default {
    name: 'c-electronic-instruction-brand-tiles',
    components: {
      eButton,
    },

    // components: {},
    // mixins: [],

    props: {
      /**
       * The buttons to render.
       */
      brands: {
        type: Array,
        default: () => [],
      },

      /**
       * The selected button.
       */
      activeValue: {
        type: String,
        default: null,
      },
    },

    emits: ['selected'],

    // data() {
    //   return {};
    // },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    methods: {
      /**
       * Stores the current search query in the URL.
       *
       * @param {Object} brandLabel - The selected brand label.
       */
      updateUrl(brandLabel) {
        const search = new URLSearchParams();

        if (brandLabel) {
          search.set(URL_PARAM_MAP.eifuBrand, brandLabel);
        } else {
          search.delete(URL_PARAM_MAP.eifuBrand);
        }

        // Needed because of the search term $nextTick delay. otherwise the url parameter will be removed from the search component.
        setTimeout(() => {
          window.history.replaceState(null, null, `?${search.toString()}`);
        }, 50);
      },

      /**
       * Triggered when a brand button is selected.
       *
       * @param {Object} brand - The selected brand.
       */
      onSelected(brand) {
        this.updateUrl(brand.label);
        this.$emit('selected', brand.label);
      },
    },
    // render() {},
  };
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  // @use '@/setup/scss/extends' as *;

  .c-electronic-instruction-brand-tiles {
    position: relative;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: variables.$spacing--30;
    padding: 0 variables.$spacing--15;

    @include mixins.media(null, xs) {
      max-height: functions.calc-rem(265px); // fits 2.5 buttons
      overflow-y: scroll;
    }

    @include mixins.media(sm) {
      grid-template-columns: repeat(2, 1fr);
      padding: 0 variables.$spacing--20;
    }

    @include mixins.media(md) {
      grid-template-columns: repeat(3, 1fr);
      padding: 0 variables.$spacing--130;
    }

    &::after {
      position: sticky;
      bottom: 0;
      content: '';
      width: 100%;
      box-shadow: 5px 7px 10px 10px rgba(variables.$color-grayscale--1000, 0.6);

      @include mixins.media(sm) {
        display: none;
      }
    }

    &__brand-button {
      padding: functions.rem(variables.$spacing--25);

      .e-button__inner {
        display: flex;
        justify-content: space-between;
      }
    }
  }
</style>
